import React, { useEffect, useState } from "react";
import { rotateImageFileAsync } from "../../src/api/chats";
import { updateImageRotateInfo } from "../../src/redux/actions";
import { useRedux } from "hooks";
import { Link } from "react-router-dom";
import { Utils } from "helpers/utils";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import { IconButton } from "yet-another-react-lightbox/core";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Share from "yet-another-react-lightbox/plugins/share";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Download from "yet-another-react-lightbox/plugins/download";


import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";

import LoadingIconWithText from "./LoadingIconWithText";

interface LightBox2Props {
  isOpen: boolean;
  onClose: () => any;
  images: Array<any>;
  defaultIdx?: number;
  allowRotate: boolean;
  showInfo?: boolean | false;
}
const LightBox2 = ({ isOpen, onClose, defaultIdx, images, allowRotate, showInfo }: LightBox2Props) => {
  const { dispatch } = useRedux();
  const [photoIndex, setPhotoIndex] = useState<number>(defaultIdx ?? 0);
  // const [rotation, setRotation] = useState(0);
  const [rotatingMode, setRotatingMode] = useState<number>(0); // 0 = None, -1 = Rotating Left, +1 = Rotating Right
  const [zoomLevel, setZoomLevel] = useState(1); // Default zoom level
  const [slices, setSlices] = useState<any[]>([]);

  useEffect(() => {
    const xx = images.map(x => (
      {
        ...x,
        src: x.downloadLink,
        share: x.downloadLink,
      }));
    setSlices(xx);
  }, []);


  useEffect(() => {
    if (defaultIdx) {
      setPhotoIndex(defaultIdx);
    }
  }, [defaultIdx]);

  const deviceOs = Utils.GetDeviceOS();
  const showDownload = deviceOs == "Windows" ? "" : "none";
  const showShare = deviceOs != "Windows";

  // useEffect(() => { console.log('view index = ' + photoIndex); }, [photoIndex]);
  const [rotating, setRotating] = useState<number>(0); // 0 = null

  const rotateImage = async (event: any, direction: number) => {
    try {
      // console.log('event:', event);
      event.target.style.disabled = true;
      event.target.classList.add("disabled");
      // setRotatingMode(direction);
      setRotating(direction);
      rotateImageFileAsync(images[photoIndex].fileId, direction)
        .then(data => {
          const fileId = images[photoIndex].fileId;
          // console.log('rotate result:', data);
          setSlices(prev => prev.map(ee => ee.fileId === fileId ? (
            {
              ...ee,
              src: data.url
            }) : ee));
          dispatch(updateImageRotateInfo(data.mId, images[photoIndex].fileId, data.url, data.urlThumb, data.degree));
          // setRotatingMode(0);
          // const d2 = degree > 0 ? 90 : -90;
          // setRotations((prev) =>
          //   prev.map((rotation, index) => {
          //     return index === photoIndex ? rotation + d2 : rotation
          //   }
          //   )
          // );
          event.target.style.disabled = false;
          event.target.classList.remove("disabled");
        }
        ).catch(error => {
          alert((error as any).message);
          console.error("Error:", error);
          event.target.style.disabled = false;
          event.target.classList.remove("disabled");
        });
    } catch (e) {
      event.target.style.disabled = false;
      event.target.classList.remove("disabled");
      console.error(e);
      alert((e as any).message);
    }
  }

  // const bxRotateRight = (rotatingMode == 1 ? "bx bx-loader-circle bx-spin" : "bx bx-rotate-right");
  // const bxRotateLeft = (rotatingMode == -1 ? "bx bx-loader-circle bx-spin" : "bx bx-rotate-left");

  const handleShareImageFile = async (imageUrl: string, fileName = "image.jpg") => {
    try {
      // Fetch the image as a blob

      // window.alert('fetch image from ' + imageUrl);
      const response = await fetch(imageUrl);
      // window.alert('create blob memory');
      const blob = await response.blob();

      // Create a File object from the blob
      // window.alert('create file object');
      const file = new File([blob], fileName, { type: blob.type });

      // window.alert('navigator share');
      // Check if the device supports sharing files
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          // title: "แชร์รูปภาพ",
          // text: fileName,
          files: [file], // Share the actual image file
        });
      } else {
        alert("File sharing is not supported on this device.");
      }
    } catch (error) {
      const msg = (error as any).message;
      const isCancel = msg.includes('cancellation');
      if (!isCancel) {
        console.error("Error sharing image:", error);
        alert(imageUrl + ':' + (error as any).message);
      }
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const prevButton = document.querySelector('.yarl__navigation_prev');
      const nextButton = document.querySelector('.yarl__navigation_next');

      if (prevButton) {
        if (photoIndex === 0) {
          prevButton.classList.add('hide');
        } else {
          prevButton.classList.remove('hide');
        }
      }

      if (nextButton) {
        if (photoIndex === slices.length - 1) {
          nextButton.classList.add('hide');
        } else {
          nextButton.classList.remove('hide');
        }
      }
      // console.log('class list:', [prevButton, nextButton]);
    }, 0); // Runs right after paint
    return () => clearTimeout(timeoutId);
  }, [photoIndex, slices.length]);

  useEffect(() => {
    // console.log('showInfo = ' + showInfo);
  }, [showInfo]);

  const toWebp = (url: string) =>
    url.replace(/\.(jpg|jpeg|png)$/i, ".webp");

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;

    if (!img.dataset.fallback) {
      img.dataset.fallback = "true";
      img.src = toWebp(img.src);
    }
  };

  return (
    <>
      {isOpen && (
        <>
          <Lightbox open={isOpen} close={onClose}
            slides={slices}
            // slides={[
            //   { src: "https://localhost:7136/_upload/2025/06/26/159/A01.JPG" },
            //   { src: "https://localhost:7136/_upload/2025/06/26/159/A02.JPG" },
            //   { src: "https://localhost:7136/_upload/2025/06/26/159/A03.JPG" },
            //   { src: "https://localhost:7136/_upload/2025/06/26/159/A04.JPG" },
            // ]}
            // plugins={[Zoom, /*Share, Download*/]}
            plugins={showInfo ? [Zoom, Captions] : [Zoom]} // 20250729

            toolbar={{
              buttons: [
                allowRotate ? (<button onClick={(e) => rotateImage(e, -1)} key="my-button-rl" type="button" className="yarl__button">
                  <i style={{ fontSize: "1.4em" }} className="fa fa-rotate-left"></i>
                </button>) : null,

                allowRotate ? (<button onClick={(e) => rotateImage(e, +1)} key="my-button-rr" type="button" className="yarl__button">
                  <i style={{ fontSize: "1.4em" }} className="fa fa-rotate-right"></i>
                </button>) : null,

                showShare ? (
                  <button onClick={(e) => handleShareImageFile(images[photoIndex].downloadLink)} key="my-button-sh" type="button" className="yarl__button">
                    <i style={{ fontSize: "1.4em" }} className="fas fa-share-alt"></i>
                  </button>) : null,

                "close",
              ],
            }}

            zoom={{
              maxZoomPixelRatio: 3,        // ✅ Allow zoom even for small images
              scrollToZoom: true,          // Optional: enable scroll-to-zoom
              doubleTapDelay: 300,
              zoomInMultiplier: 2
            }}

            index={photoIndex}

            on={{
              view: ({ index: newIndex }) => {
                setPhotoIndex(newIndex); // <-- this keeps track of the current index
                // console.log(`view image: ${newIndex}/${slices.length - 1}`);

                // const prevButton = document.querySelector('.yarl__navigation_prev');
                // const nextButton = document.querySelector('.yarl__navigation_next');

                // if (prevButton) {
                //   if (newIndex === 0) {
                //     prevButton.classList.add('hide');
                //   } else {
                //     prevButton.classList.remove('hide');
                //   }
                // }

                // if (nextButton) {
                //   if (newIndex === slices.length - 1) {
                //     nextButton.classList.add('hide');
                //   } else {
                //     nextButton.classList.remove('hide');
                //   }
                // }
              }
            }}

            render={{
              slide: ({ slide }) => (
                <img
                  src={slide.src}
                  onError={handleError}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              ),
            }}
          ></Lightbox>
        </>
      )
      }

    </>
  );
};

export default LightBox2;
